module.exports = __webpack_public_path__ + "img/platum@3x.371e4f59.png";